module.exports = __webpack_public_path__ + "img/image.bfd4dca0.png";